<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter
                    :orderbutton="true"
                    :listStatus="complain_status_list"
                    :orderSummary="orderSummary"
                    :headers="filter_headers"
                    :viewName="viewName"
                    v-on:applyFilter="applyFilter"
                    v-on:quickFilter="quickFilter"
                ></hpo-filter>
                <v-data-table :headers="headers" :items="orders" :must-sort="true" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ID }}</td>
                            <td class="text-center complain-order-cell">
                                <div class="font-weight-bold mb-2">{{ item.OrderID }}</div>
                                <v-btn x-small color="primary" dark @click="gotoOrderDetail(item)">
                                    Xem đơn hàng
                                </v-btn>
                            </td>
                            <td>{{ item.Username }}</td>
                            <td class="complain-staff-cell">
                                <div><strong>KD:</strong> {{ item.SalerName || '-' }}</div>
                                <div><strong>ĐH:</strong> {{ item.BuyerName || '-' }}</div>
                                <div><strong>CSKH:</strong> {{ item.CustomerServiceName || '-' }}</div>
                            </td>
                            <td class="text-end font-weight-bold">
                                <div>{{ item.Amount | currency }}</div>
                                <div class="caption text-uppercase">VND</div>
                            </td>
                            <td class="complain-content-cell">{{ item.ComplainText }}</td>
                            <td style="min-width: 220px">
                                <v-select
                                    :value="item.Status"
                                    :items="complain_status_list"
                                    :disabled="isFinished(item)"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    hide-details
                                    @change="updateStatus(item, $event)"
                                ></v-select>
                            </td>
                            <td class="complain-note-cell">
                                <v-textarea
                                    v-model="item.NoteOfStaff"
                                    :disabled="isFinished(item)"
                                    dense
                                    outlined
                                    hide-details
                                    rows="2"
                                    @change="updateInternalNote(item)"
                                ></v-textarea>
                            </td>
                            <td class="text-center font-weight-medium">
                                {{ formatComplainAge(item.ComplainAgeDays) }}
                            </td>
                            <td class="text-center">
                                <div>{{ item.CreatedDate | display_date('DD/MM/YYYY') }}</div>
                                <div>{{ item.CreatedDate | display_date('HH:mm') }}</div>
                            </td>
                            <td class="text-center">
                                <v-btn x-small color="primary" dark @click="gotoDetail(item.ID, item.UID)">Xem</v-btn>
                                <v-icon v-if="!isFinished(item)" medium title="Từ chối khiếu nại" @click="rejectItem(item.ID)">fa-times-circle</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            search: "",
            headers: [{
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Đơn hàng",
                    value: "OrderID",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Username",
                    value: "Username",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Nhân viên",
                    value: "Staff",
                    sortable: false,
                    filterable: false
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Nội dung",
                    value: "ComplainText",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: configs.COMPLAIN_STATUS_LIST
                },
                {
                    text: "Ghi chú nội bộ",
                    value: "NoteOfStaff",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"],
                    sortable: false
                },
                {
                    text: "TG tạo KN",
                    value: "ComplainAgeDays",
                    align: "center",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            complain_status_list: configs.COMPLAIN_STATUS_LIST,
            complain_status: configs.COMPLAIN_STATUS,
            pagination: { ...configs.PAGINATION},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "complain_list",
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            orders: state => state.complain.all.data,
            total_rows: state => state.complain.all.total,
            loading: state => state.complain.loading,
            orderSummary: state => state.complain.all.summary || {},
        }),
        filter_headers() {
            const dataType = configs.DATA_TYPE;
            return [
                {
                    text: 'ID',
                    value: 'ID',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.Number
                },
                {
                    text: 'Đơn hàng',
                    value: 'OrderID',
                    filterable: true,
                    dataType: dataType.Number
                },
                {
                    text: 'Username',
                    value: 'Username',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'Nhân viên KD',
                    value: 'SalerName',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'Nhân viên ĐH',
                    value: 'BuyerName',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'Nhân viên CSKH',
                    value: 'CustomerServiceName',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'Số tiền',
                    value: 'Amount',
                    filterable: true,
                    dataType: dataType.Number
                },
                {
                    text: 'Nội dung',
                    value: 'ComplainText',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'Trạng thái',
                    value: 'Status',
                    filterable: true,
                    dataType: dataType.Enum,
                    values: configs.COMPLAIN_STATUS_LIST
                },
                {
                    text: 'Ghi chú nội bộ',
                    value: 'NoteOfStaff',
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType.String
                },
                {
                    text: 'TG tạo KN',
                    value: 'ComplainAgeDays',
                    filterable: true,
                    dataType: dataType.Number
                },
                {
                    text: 'Ngày tạo',
                    value: 'CreatedDate',
                    filterable: true,
                    dataType: dataType.Date
                }
            ];
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("complain/getList", param);
        },
        gotoDetail: function (id, uid) {
            let routeData = this.$router.resolve({
                name: "ComplainDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết khiếu nại (#${id})`
                },
                query: {
                    'uid': uid
                }
            });
            window.open(routeData.href, "_blank");
        },
        gotoOrderDetail(item) {
            const isDeposit = Number(item.OrderType) === 2;
            const routeData = this.$router.resolve({
                name: isDeposit ? 'DepositDetail' : 'OrderDetail',
                params: {
                    Pid: item.OrderID,
                    title: `Chi tiết đơn hàng (#${item.OrderID})`
                },
                query: isDeposit ? { uid: item.UID } : {}
            });
            window.open(routeData.href, '_blank');
        },
        rejectItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, `Bạn muốn từ chối khiếu nại #${id} ?`);
        },
        updateStatus(item, status) {
            item.Status = status;
            this.$store.dispatch('complain/setDetail', {
                ID: item.ID,
                Status: status
            });
            setTimeout(this.filter_data, 200);
        },
        updateInternalNote(item) {
            this.$store.dispatch('complain/setDetail', {
                ID: item.ID,
                NoteOfStaff: item.NoteOfStaff
            });
        },
        formatComplainAge(days) {
            if (days === null || days === undefined || days === '') {
                return '-';
            }
            return `${Number(days)} ngày`;
        },
        isFinished(item) {
            return Number(item.Status) === this.complain_status.Finished;
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
            var updateComplain = {
                "ID": id,
                "Status": this.complain_status.Rejected
            }
            this.$store.dispatch("complain/setDetail", updateComplain);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>

<style scoped>
.complain-order-cell {
    min-width: 130px;
}

.complain-staff-cell {
    min-width: 150px;
    line-height: 1.8;
}

.complain-content-cell {
    min-width: 320px;
    white-space: normal;
}

.complain-note-cell {
    min-width: 280px;
}
</style>
